import {
  FamilyResourceTag,
  ResourceFamilyPickerDataProviderBase,
  ResourceFamilyResults
} from '../../../../picker/family-resource-picker-data';
import { GraphicalFamilyResourcePicker } from '../../../../picker/graphical-family-resource-picker';
import type { NullPromise } from '../../../../../webmodule-common/other/ui/events';
import { v6ApiInjecterEvent } from '../../../../v6config/v6config';

// Dealer-bundle endpoint that fetches family/resource tree data straight from V6,
// mirroring the scriptsV6 V6ResourceFamilyPickerDataProvider but using the dealer's
// direct-V6 comms (we must not import scriptsV6 into the scripts bundle).
export class PoResourceFamilyEndpoint extends ResourceFamilyPickerDataProviderBase {
  private supplierId: string;
  private resourceClass: number;
  private readonly comms = v6ApiInjecterEvent();

  constructor(supplierId: string, resourceClass: number) {
    super();
    this.supplierId = supplierId;
    this.resourceClass = resourceClass;
  }

  override getResourceClass(): number {
    return this.resourceClass;
  }

  override async getData(): Promise<ResourceFamilyResults | null> {
    const r = await this.comms.post<ResourceFamilyResults>('api/v6/ConfigItem/GetResourceBrowserInformation', {
      supplierCode: this.supplierId,
      familyReference: '',
      resourceClass: this.resourceClass,
      tags: ''
    });
    return r ?? null;
  }

  override getResourceImageUrl(resourceClass: number, libId: number, id: number): string {
    return this.comms.fullUrl(
      `api/v6/ConfigItem/Resource/${this.supplierId}/${resourceClass}/${libId}/${id}/resfile.jpg`
    );
  }

  override getFamilyImageUrl(resourceClass: number, libId: number, id: number): string {
    return this.comms.fullUrl(
      `api/v6/ConfigItem/Family/${this.supplierId}/${resourceClass}/${libId}/${id}/resfile.jpg`
    );
  }
}

export async function pickResourceFamily(
  supplierId: string,
  resourceClass: number,
  title: string
): NullPromise<FamilyResourceTag> {
  const endpoint = new PoResourceFamilyEndpoint(supplierId, resourceClass);
  const gp = new GraphicalFamilyResourcePicker(endpoint, {
    resourceName: title,
    sideBar: null,
    // pickImmediately: click a resource to pick it and close (no separate Select step;
    // the picker shows no selection highlight otherwise, which reads as "nothing happened").
    pickImmediately: true,
    // Show the text filter so resources can be searched as well as navigated via the tree.
    show: { tree: true, filter: true, cancelButton: true },
    hideImages: false,
    // Use the frame picker's reduced thumbnail size (no size toggle shown).
    smallThumbnails: true,
    // Subfolders are navigable in the left tree, so don't repeat them as tiles above the resources.
    hideFamilyTiles: true,
    modalSize: 'modal-fullscreen',
    title
  });
  await gp.showModal();
  return gp.selected ?? null;
}
